import { useState } from 'react';
import { Col, Container, Form, FormGroup, Input, Label, Row, Spinner } from 'reactstrap';
import CommonLogo from '../Common/CommonLogo';
import { Btn, H4, P, Image } from '../../../../AbstractElements';
import { SignIn } from '../../../../utils/Constant';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import AuthService from '../../../../Api/services/auth.service';
import { useTranslation } from 'react-i18next';
import { dynamicImage } from "../../../../Service";

const ForgetPasswordContainer = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!email) {
      toast.error(t("Por favor ingresa tu email"));
      return;
    }

    setLoading(true);
    try {
      const response = await AuthService.forgotPassword(email);
      
      // Guardar el ID en localStorage para usar en los siguientes pasos
      localStorage.setItem('forgotPasswordId', response.id.toString());
      
      toast.success(t("Código de recuperación enviado a tu email"));
      
      // Navegar a la página de verificación de código
      navigate(`${process.env.PUBLIC_URL}/authentication/verify-code`, { 
        state: { email, forgotPasswordId: response.id } 
      });
    } catch (error: any) {
      const errorMessage = 
        error.response?.data?.detail || 
        error.message || 
        t("Error al solicitar recuperación de contraseña");
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-wrapper">
      <Container fluid className="p-0">
        <Row>
          <Col xs="12">
            <div className="login-card login-dark">
              <div>
                <div>
                  <div className="logo text-center">
                    <Image className="img-fluid for-light mx-auto" src={dynamicImage("logo/logo.png")} alt="logo" width={450} />
                  </div>
                </div>
                <div className="login-main">
                  <Form className="theme-form" onSubmit={handleSubmit}>
                    <H4>{t("ResetYourPassword")}</H4>
                    <P className="text-muted mb-4">
                      {t("Ingresa tu email y te enviaremos un código de recuperación")}
                    </P>
                    <FormGroup>
                      <Label className="col-form-label">{t("Email")}</Label>
                      <Input
                        type="email"
                        required
                        placeholder={t("ejemplo@email.com")}
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        disabled={loading}
                      />
                    </FormGroup>
                    <FormGroup className="mb-0">
                      <Btn 
                        color="primary" 
                        block 
                        className="w-100"
                        disabled={loading}
                        type="submit"
                      >
                        {loading ? (
                          <>
                            <Spinner size="sm" className="me-2" />
                            {t("Enviando...")}
                          </>
                        ) : (
                          t("Enviar Código")
                        )}
                      </Btn>
                    </FormGroup>
                    <P className="mt-4 mb-0 text-center">
                      {t("¿Ya tienes una cuenta?")}
                      <Link className="ms-2" to={`${process.env.PUBLIC_URL}/login`}>
                        {t("SignIn")}
                      </Link>
                    </P>
                  </Form>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ForgetPasswordContainer;
